import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';
import { fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';
import { io } from 'socket.io-client';

import * as ɵngcc0 from '@angular/core';
const SOCKETIO_CONFIG = new InjectionToken('SocketioConfig');

class Socket {
    constructor({ url, options }) {
        this.socket = io(url, options);
    }
    /**
     * @see {@link Socket.id}
     */
    get id() { return this.socket.id; }
    ;
    /**
     * @see {@link Socket.connected}
     */
    get connected() { return this.socket.connected; }
    ;
    /**
     * @see {@link Socket.disconnected}
     */
    get disconnected() { return this.socket.disconnected; }
    ;
    /**
     * @see {@link Socket.io}
     */
    get io() { return this.socket.io; }
    ;
    /**
     * @see {@link Socket.auth}
     */
    get auth() { return this.socket.auth; }
    ;
    /**
     * @see {@link Socket.auth}
     */
    set auth(auth) { this.socket.auth = auth; }
    ;
    ngOnDestroy() {
        this.socket.offAny();
    }
    /**
     * @see {@link Socket.connect}
     */
    connect() {
        this.socket.connect();
        return this;
    }
    /**
     * @see {@link Socket.disconnect}
     */
    disconnect() {
        this.socket.disconnect();
        return this;
    }
    /**
     * @see {@link Socket.send}
     */
    send(...args) {
        this.socket.send(...args);
        return this;
    }
    /**
     * @see {@link Socket.emit}
     */
    emit(eventName, ...args) {
        this.socket.emit(eventName, ...args);
        return this;
    }
    /**
     * @see {@link Socket.on}
     */
    on(eventName) {
        return fromEvent(this.socket, eventName);
    }
    /**
     * @see {@link Socket.once}
     */
    once(eventName) {
        return this.on(eventName).pipe(take(1));
    }
    /**
     * @see {@link Socket.compress}
     */
    compress(compress) {
        this.socket.compress(compress);
        return this;
    }
}
Socket.ɵfac = function Socket_Factory(t) { return new (t || Socket)(ɵngcc0.ɵɵinject(SOCKETIO_CONFIG)); };
Socket.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: Socket, factory: Socket.ɵfac });
Socket.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [SOCKETIO_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Socket, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SOCKETIO_CONFIG]
            }] }]; }, null); })();

class SocketioModule {
    static forRoot(config = { url: '' }) {
        return {
            ngModule: SocketioModule,
            providers: [
                { provide: SOCKETIO_CONFIG, useValue: config },
                Socket,
            ],
        };
    }
}
SocketioModule.ɵfac = function SocketioModule_Factory(t) { return new (t || SocketioModule)(); };
SocketioModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SocketioModule });
SocketioModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SocketioModule, [{
        type: NgModule
    }], null, null); })();

/*
 * Public API Surface of ngx-socketio2
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Socket, SocketioModule, SOCKETIO_CONFIG as ɵa };

